'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChangeEvent } from 'react';
import { styled } from '@classify/react-core-components/styles';
import { useFormikContext } from 'formik';
import { Radio, RadioGroup } from '@mui/material';
import { useUpdateQuizSessionQuestionsAnswers } from '@openclassrooms/data-connect-web/assessment';
import type { Answer } from '@openclassrooms/sdk-web';
import { translate } from '@openclassrooms/translations';
import AnswerWrapper from './AnswerWrapper';
import { SingleAnswerWrong, SingleAnswerRight } from './AnswerIcons';
const StatusIcon = styled('svg')({
  flexShrink: 0,
  width: 20,
  height: 20
});
const IconWrapper = styled('span')(({
  theme: {
    spacing
  }
}) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: spacing(1),
  width: 24,
  height: 24
}));
interface Props {
  answers: Answer[];
  isCompleted?: boolean;
  questionId: number;
  quizSessionQuestionId: number;
}
export default function SingleAnswerQuestion(t0) {
  const $ = _c(24);
  const {
    answers,
    isCompleted: t1,
    questionId,
    quizSessionQuestionId
  } = t0;
  const isCompleted = t1 === undefined ? false : t1;
  const {
    values,
    setFieldValue
  } = useFormikContext();
  let t2;
  if ($[0] !== quizSessionQuestionId) {
    t2 = {
      quizSessionQuestionId
    };
    $[0] = quizSessionQuestionId;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [updateAnswer] = useUpdateQuizSessionQuestionsAnswers(t2);
  let t3;
  if ($[2] !== questionId || $[3] !== values) {
    t3 = values[questionId] ?? [];
    $[2] = questionId;
    $[3] = values;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const [answer] = t3;
  const selectedAnswer = answer ?? "";
  let t4;
  if ($[5] !== isCompleted || $[6] !== questionId || $[7] !== setFieldValue || $[8] !== updateAnswer) {
    t4 = e => {
      if (isCompleted) {
        return;
      }
      const answerNumber = Number(e.target.value);
      setFieldValue(`${questionId}`, [answerNumber]);
      updateAnswer([answerNumber]);
    };
    $[5] = isCompleted;
    $[6] = questionId;
    $[7] = setFieldValue;
    $[8] = updateAnswer;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleChange = t4;
  const getControlElement = _temp;
  const t5 = `${questionId}`;
  let t6;
  if ($[10] !== answers || $[11] !== isCompleted || $[12] !== questionId || $[13] !== selectedAnswer) {
    let t7;
    if ($[15] !== isCompleted || $[16] !== questionId || $[17] !== selectedAnswer) {
      t7 = t8 => {
        const {
          id: id_0,
          content,
          isCorrect: isCorrect_0
        } = t8;
        const isChecked_0 = id_0 === selectedAnswer;
        const isCorrectAnswer = Boolean(isCorrect_0);
        return <AnswerWrapper key={`${questionId}-${id_0}`} content={content} isCorrect={isCorrectAnswer} control={getControlElement(isCorrect_0, isChecked_0, id_0)} isCompleted={isCompleted} warningLabel={isCorrectAnswer && !isChecked_0 ? translate("quiz.correction.question.item.single_choice.answer_missing") : null} />;
      };
      $[15] = isCompleted;
      $[16] = questionId;
      $[17] = selectedAnswer;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    t6 = answers.map(t7);
    $[10] = answers;
    $[11] = isCompleted;
    $[12] = questionId;
    $[13] = selectedAnswer;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[19] !== handleChange || $[20] !== selectedAnswer || $[21] !== t5 || $[22] !== t6) {
    t7 = <RadioGroup name={t5} value={selectedAnswer} onChange={handleChange}>{t6}</RadioGroup>;
    $[19] = handleChange;
    $[20] = selectedAnswer;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
}
function _temp(isCorrect, isChecked, id) {
  if (isCorrect === null || isCorrect === undefined || !isChecked) {
    return <Radio color="primary" value={`${id}`} checked={isChecked} inputProps={{
      "data-testid": "answer"
    }} />;
  }
  if (isCorrect && isChecked) {
    return <IconWrapper aria-checked="true"><StatusIcon as={SingleAnswerRight} data-testid="check-icon" /></IconWrapper>;
  }
  return <IconWrapper aria-checked="true"><StatusIcon as={SingleAnswerWrong} data-testid="cross-icon" /></IconWrapper>;
}